module.exports = __webpack_public_path__ + "img/29.84d8cb3f.png";